export var Area = function (Area) {
  Area["PI"] = "pi";
  Area["CCUI"] = "ccui";
  Area["BB"] = "bb";
  return Area;
}({});